<div class="bills-page">
  <header class="dashboard-header">
    <div class="left-section">
      <h1 class="dashboard-title">Pay Bills</h1>
    </div>
    <div class="right-section">
      <img src="assets/icons/img-notification.svg" class="bell-icon" alt="Notifications"
        (click)="toggleNotifications()" />
    </div>
  </header>

  <main class="bills-content">
    <!-- Step 0: Main selection -->
    <div *ngIf="currentStep === 'selection'" class="dark-selection-box fade-in">
      <div class="selection-header">
        <h2>Transfer Funds</h2>
        <button class="close-x" (click)="goBack()">
          <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="#777" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg> -->
          <img src="assets/icons/close-gray.png" alt="Close">
        </button>
      </div>

      <div class="selection-grid">
        <div class="figma-card" (click)="goToUtilityCategories()">
          <div class="icon-square-vibrant">
            <img src="assets/icons/home.svg" alt="Utility" />
          </div>
          <div class="card-label-bottom">Pay Utility Bills</div>
        </div>

        <div class="figma-card" (click)="goToMobileCategories()">
          <div class="icon-square-vibrant">
            <img src="assets/icons/mobile.svg" alt="Mobile" />
          </div>
          <div class="card-label-bottom">Mobile & DTH Recharge</div>
        </div>

        <div class="figma-card" (click)="goToCreditCardCategories()">
          <div class="icon-square-vibrant">
            <img src="assets/icons/card.svg" alt="Credit Card" />
          </div>
          <div class="card-label-bottom">Credit Card Bill Payment</div>
        </div>
      </div>
    </div>

    <!-- Step: Utility Categories -->
    <div *ngIf="currentStep === 'categories'" class="figma-cat-modal fade-in">
      <div class="figma-modal-header">
        <h2 class="figma-modal-title">Pay Utility Bills</h2>
        <button class="figma-close-icon" (click)="goBack()">
          <img src="assets/icons/close-gray.png" alt="Close" />
        </button>
      </div>
      <div class="figma-modal-content">
        <div class="figma-cat-dual-grid">
          <div *ngFor="let cat of categories" class="figma-cat-horizontal-card" (click)="selectCategory(cat)">
            <div class="figma-cat-icon-box" [ngClass]="cat.id">
              <img [src]="cat.icon" [alt]="cat.name" />
            </div>
            <div class="figma-cat-label">{{cat.name}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Step: Mobile Categories -->
    <div *ngIf="currentStep === 'mobile-categories'" class="figma-cat-modal compact-modal fade-in">
      <div class="figma-modal-header">
        <h2 class="figma-modal-title">Mobile & DTH Recharge</h2>
        <button class="figma-close-icon" (click)="goBack()">
          <img src="assets/icons/close-48.png" alt="Close">
        </button>
      </div>

      <div class="figma-modal-content">
        <div class="operators-grid">
          <div *ngFor="let op of mobileCategories" class="operator-card" (click)="selectCategory(op)">
            <div class="logo-box">
              <img [src]="op.icon" [alt]="op.name">
            </div>
            <div class="operator-info">
              <span class="name">{{op.name}}</span>
              <span class="arrow">→</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Step: Credit Card Categories -->
    <div *ngIf="currentStep === 'credit-categories'" class="credit-card-page-view fade-in">
      <div class="figma-cat-modal credit-card-modal">
        <div class="figma-modal-header">
          <h2 class="figma-modal-title">Credit Card Bill Payment</h2>
          <button class="figma-close-icon" (click)="goBack()">
            <img src="assets/icons/close-gray.png" alt="Close">
          </button>
        </div>

        <div class="figma-modal-content">
          <div class="saved-cards-list">
            <div *ngFor="let card of creditCards" class="saved-card-item" (click)="openCreditCardForm(card)">
              <div class="card-left">
                <div class="card-logo-box">
                  <img [src]="card.logo" [alt]="card.bank" onerror="this.src='assets/icons/img-bank.svg'">
                </div>
                <div class="card-info">
                  <div class="card-name">{{card.bank}}</div>
                  <div class="card-num">**** {{card.lastFour}}</div>
                </div>
              </div>
              <div class="card-right">
                <div class="amount">{{card.amount}}</div>
                <div class="due-date">{{card.dueDate}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="add-card-action-outside">
        <button class="btn-add-card">Add Credit Card</button>
      </div>
    </div>

    <!-- Step: Utility Form -->
    <app-pay-utility-bills-form *ngIf="currentStep === 'form'" [category]="selectedCategory" (close)="goBack()">
    </app-pay-utility-bills-form>

    <!-- Step: Mobile Form (To be implemented) -->
    <div *ngIf="currentStep === 'mobile-form'">
      <app-mobile-recharge-form *ngIf="currentStep === 'mobile-form'" [category]="selectedCategory"
        (back)="goBack($event)"></app-mobile-recharge-form>
    </div>

    <!-- Step: Credit Card Form (To be implemented) -->
    <div *ngIf="currentStep === 'credit-form'">
      <app-credit-card-bill-form *ngIf="currentStep === 'credit-form'" [cards]="creditCards"
        [selectedCard]="selectedCreditCard" (back)="goBack($event)"></app-credit-card-bill-form>
    </div>
  </main>
</div>